<template>
  <div id="" class="">
      <el-dialog title="已有大类" :visible.sync="isShowdialog" :before-close="beforeClose" width="60%" top="5%">
        <div id="attendance_record">
            <common-search :searchList="searchList" @onSearch="onSearch" type="category"></common-search>

            <common-table
              :product_list="product_list"
              :loading="loading"
              @sort-change="sortChange"
              @data-change="getMessageByPage"
              storageName="checkedHeaders_category"
              title="请点击想要选择的数据列后点击确定"
              type="category"
              height="450"
              :tableHandler="tableHandler"
              :newCheckHeader="checkedHeaders"
              ></common-table>

            <div style="text-align: right;margin-top:10px">
               <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="pageSizes"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total">
              </el-pagination>
            </div>

            <div style="display: flex;justify-content: flex-end;margin-top: 20px">
              <el-button @click="beforeClose">关闭</el-button>
            </div>

        </div>
      </el-dialog>
  </div>
</template>
<script>
export default {
  props:['dialogVisible','otype'],
  watch: {
    dialogVisible(val){
      this.isShowdialog = val;
      if(val){
        this.getMessageByPage();
      }
    }
  },
  data() {
    return {
      isShowdialog: false,
      loading: false,
      product_list: null,
      machineNO: '',
      name: '',
      verificationValidDate:[],
      currentPage: 1,
      total: 0,
      pageSizes: [10, 20, 50],
      pageSize: 10,
      product: {},
      searchList: {
        categoryName: '',
      },
      tableHandler: [
        //'edit',
      ],
      newSearchList: null,
      checkedHeaders: ['大类名称'],
    }
  },
  methods:{
    cancel(){
      this.$refs.record_table.setCurrentRow();
    },

    beforeClose(done){
      this.product = {};
      this.isShowdialog = false;
      this.$emit('change-state',{isShow: this.isShowDialog,dialog:'searchCategory'});
    },

    async getMessageByPage(){
      this.loading = true;
      let _searchList = this.newSearchList ? this.newSearchList : this.searchList
      let options = this.$util.formatOptions(_searchList);
      if(this.$util.isEmpty(this.order))
        this.order = "default";

      const product_list = await this.$request.get_message('categories',{page: this.currentPage,limit: this.pageSize,query: options});
      //console.log(product_list);
      if(product_list.code === 0){
        this.product_list = product_list.data;
        this.total = product_list.total;
      }else{
        this.$message(product_list['errMsg'])
      }
      this.loading = false;
    },

    handleSizeChange(val) {
      //console.log(`每页 ${val} 条`);
      this.pageSize = val;
      this.getMessageByPage();
    },

    handleCurrentChange(val) {
      //console.log(`当前页: ${val}`);
      this.currentPage = val;
      this.getMessageByPage();
    },

    onSearch(val){
      this.$commondata.searchObj = this.searchList;
      this.newSearchList = Object.assign({}, this.searchList);
      this.getMessageByPage();
    },

    sortChange(val){
      this.order = val.order;
      this.getMessageByPage();
    },
  },
}
</script>

<style type="text/css">

</style>



// WEBPACK FOOTER //
// src/components/dialog/SearchCategoryDialog.vue